
var showDates = document.querySelectorAll(".show-date");

showDates.forEach( function ( showDate ) {
	var date = new Date();
	var months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
	showDate.innerHTML = ("0" + date.getDate()).slice(-2) + ' de ' + months[date.getMonth()] + ' de ' + date.getUTCFullYear();
} );
